































import {Component, Emit, Prop, Vue} from "vue-property-decorator";
import InfiniteLoading from "vue-infinite-loading";
import LoadSpinner from "@/resources/components/LoadSpinner.vue";
import Debounce from "@/app/support/Debounce";

export interface Loadable {
    loadItems: (items: any[]) => void
    page: number
}

@Component({
    components: {
        "infinite-loading": InfiniteLoading,
        "load-spinner": LoadSpinner,
    },
})
export default class BaseOverview extends Vue {
    @Prop({required: false, default: () => "Dit zijn alle resultaten."}) noMore!: string;
    @Prop({required: false, default: () => "Geen resultaten gevonden."}) noResults!: string;

    page: number = 1;
    items: any[] = [];

    // noinspection JSAnnotator
    $refs!: {
        infiniteLoading: InfiniteLoading;
    };

    @Emit("load-items")
    loadItems({loaded, complete}: any): Loadable {
        return {
            loadItems: (items: any[]): void => {
                if (typeof items === 'undefined' || items.length === 0) {
                    complete();
                }
                this.items = this.items.concat(items);
                loaded();
                this.page++;
            },
            page: this.page,
        };
    }

    public reset() {
        this.page = 1;
        this.items = [];
        this.$refs.infiniteLoading.stateChanger.reset();
    }
}
